import { useEffect, useState } from "react";
import { Cookie } from "lucide-react";
import { Button } from "@/components/kit";

const KEY = "resada_cookie_consent";

export default function CookieConsent() {
  const [show, setShow] = useState(false);
  useEffect(() => {
    if (!localStorage.getItem(KEY)) {
      const t = setTimeout(() => setShow(true), 800);
      return () => clearTimeout(t);
    }
  }, []);
  const decide = (v) => { localStorage.setItem(KEY, v); setShow(false); };
  if (!show) return null;
  return (
    <div className="fixed bottom-4 left-4 right-4 sm:left-auto sm:right-5 sm:max-w-md z-[80] animate-float-up" data-testid="cookie-consent">
      <div className="bg-white rounded-2xl shadow-2xl border border-slate-100 p-5">
        <div className="flex items-start gap-3">
          <span className="w-10 h-10 rounded-xl bg-amber-100 grid place-items-center shrink-0"><Cookie className="w-5 h-5 text-amber-600" /></span>
          <div className="min-w-0">
            <p className="font-display font-bold text-slate-800 text-sm">Kami menggunakan cookie 🍪</p>
            <p className="text-xs text-slate-500 mt-1 leading-relaxed">RESADA memakai cookie untuk meningkatkan pengalaman, menganalisa trafik, dan personalisasi konten. Pilihanmu kami simpan di perangkat ini.</p>
          </div>
        </div>
        <div className="flex gap-2 mt-4">
          <button onClick={() => decide("rejected")} data-testid="cookie-reject"
            className="flex-1 text-sm font-semibold text-slate-600 border border-slate-200 rounded-xl py-2 hover:bg-slate-50 transition">Tolak</button>
          <Button onClick={() => decide("accepted")} data-testid="cookie-accept" className="flex-1">Terima</Button>
        </div>
      </div>
    </div>
  );
}
